export const enumToFormOptions = (enumObject: Record<string, string>, t: any) => {
  return Object.values(enumObject).map((enumValue) => ({
    label: t(enumValue),
    value: enumValue,
  }));
};

export const objectToFormOptions = ({ name, id }: { name: string; id?: string }) => ({
  value: id || name,
  label: name,
});

export const bytesToMegaBytesSize = (size: number) => parseFloat((size / (1024 * 1024)).toFixed(2));
export const bytesToKiloBytesSize = (size: number) => parseFloat((size / 1024).toFixed(2));
